"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable class-methods-use-this */
// eslint-disable-next-line max-classes-per-file
const three_1 = require("three");
const utils_3d_1 = require("../utils/utils.3d");
const consts_1 = require("../consts");
const PointToPointDashedLeader_3d_1 = __importDefault(require("./PointToPointDashedLeader.3d"));
const PointToPointLeader_3d_1 = __importDefault(require("./PointToPointLeader.3d"));
const ScaleDependentObject_3d_1 = __importDefault(require("./ScaleDependentObject.3d"));
const EdgeUtils_3d_1 = __importDefault(require("./EdgeUtils.3d"));
class PointToPointMeasureTool {
    constructor(viewer) {
        this.isMeasurementPlaced = false;
        this.viewer = viewer;
        this.initPointCubes();
        this.initLeaders();
    }
    clear() {
        this.closestIntersection = null;
        this.startPoint = null;
        this.endPoint = null;
        this.isMeasurementPlaced = false;
        this.handleObjectSelection();
        this.handleCursorPointRender();
        this.handleLeaders();
        this.removeStartEndPointCubes();
    }
    handleMouseMove() {
        if (this.isMeasurementPlaced) {
            return;
        }
        this.closestIntersection = this.viewer.getClosestIntersectionByOuterBox();
        this.handleObjectSelection();
        this.handleCursorPointRender();
        this.handlePointSnap();
        this.handleLeaders();
    }
    handleMouseUp() {
        if (this.isMeasurementPlaced) {
            this.clear();
            this.handleMouseMove();
            return;
        }
        if (!this.hoveredObject) {
            return;
        }
        this.handleCursorPointRender(true);
        const pointCubePosition = this.cursorPointCube.position.clone();
        const scene = this.viewer.getScene();
        if (!this.startPoint) {
            this.startPoint = pointCubePosition;
            this.startPointCube.position.copy(this.startPoint);
            scene.add(this.startPointCube);
            this.hoveredObject.hideSelectionBox();
            return;
        }
        this.isMeasurementPlaced = true;
        this.endPoint = pointCubePosition;
        this.endPointCube.position.copy(this.endPoint);
        scene.add(this.endPointCube);
        this.handleObjectSelection(true);
    }
    update() {
        this.handleLeaders();
    }
    initPointCubes() {
        const geometry = new three_1.BoxGeometry(consts_1.consts.POINT_CUBE_SIZE, consts_1.consts.POINT_CUBE_SIZE, consts_1.consts.POINT_CUBE_SIZE);
        const material = new three_1.MeshBasicMaterial({
            color: consts_1.consts.POINT_CUBE_COLOR,
            opacity: consts_1.consts.POINT_CUBE_OPACITY,
            transparent: true,
            depthTest: false,
        });
        const camera = this.viewer.getCamera();
        const mesh = new three_1.Mesh(geometry, material);
        this.cursorPointCube = new ScaleDependentObject_3d_1.default(mesh, camera);
        this.startPointCube = new ScaleDependentObject_3d_1.default(mesh.clone(), camera);
        this.endPointCube = new ScaleDependentObject_3d_1.default(mesh.clone(), camera);
    }
    initLeaders() {
        const distanceLineMaterial = this.createDashedLineMaterial();
        const deltaXLeaderColor = new three_1.Color(consts_1.consts.DELTA_X_LEADER_COLOR);
        const deltaYLeaderColor = new three_1.Color(consts_1.consts.DELTA_Y_LEADER_COLOR);
        const deltaZLeaderColor = new three_1.Color(consts_1.consts.DELTA_Z_LEADER_COLOR);
        const xDeltaMaterial = this.createSolidLineMaterial(deltaXLeaderColor);
        const yDeltaMaterial = this.createSolidLineMaterial(deltaYLeaderColor);
        const zDeltaMaterial = this.createSolidLineMaterial(deltaZLeaderColor);
        this.distanceLeader = new PointToPointDashedLeader_3d_1.default(this.viewer, distanceLineMaterial, consts_1.consts.DISTANCE_LABEL_PREFIX, distanceLineMaterial.color);
        this.xDeltaLeader = new PointToPointLeader_3d_1.default(this.viewer, xDeltaMaterial, consts_1.consts.DELTA_X_LABEL_PREFIX, deltaXLeaderColor);
        this.yDeltaLeader = new PointToPointLeader_3d_1.default(this.viewer, yDeltaMaterial, consts_1.consts.DELTA_Y_LABEL_PREFIX, deltaYLeaderColor);
        this.zDeltaLeader = new PointToPointLeader_3d_1.default(this.viewer, zDeltaMaterial, consts_1.consts.DELTA_Z_LABEL_PREFIX, deltaZLeaderColor);
    }
    createDashedLineMaterial() {
        return new three_1.LineDashedMaterial({
            color: consts_1.consts.LEADER_COLOR,
            dashSize: consts_1.consts.DASH_LENGTH,
            gapSize: consts_1.consts.GAP_LENGTH,
            transparent: true,
            depthTest: false,
        });
    }
    createSolidLineMaterial(color) {
        return new three_1.LineBasicMaterial({
            color,
            transparent: true,
            depthTest: false,
        });
    }
    handleObjectSelection(shouldUnselect = false) {
        var _a;
        const hoveredPart = shouldUnselect ? null : (_a = this.closestIntersection) === null || _a === void 0 ? void 0 : _a.object.parent;
        const isAnotherPartHovered = hoveredPart && hoveredPart !== this.hoveredObject;
        if (this.hoveredObject && (!hoveredPart || isAnotherPartHovered)) {
            this.hoveredObject.unselect();
            this.hoveredObject = null;
        }
        if (!isAnotherPartHovered) {
            return;
        }
        this.hoveredObject = hoveredPart;
        if (this.startPoint) {
            this.hoveredObject.showOuterBox();
            return;
        }
        this.hoveredObject.select();
    }
    handleCursorPointRender(shouldReleasePoint = false) {
        const scene = this.viewer.getScene();
        if (!this.closestIntersection || shouldReleasePoint) {
            scene.remove(this.cursorPointCube);
            return;
        }
        this.cursorPointCube.position.copy(this.closestIntersection.point);
        scene.add(this.cursorPointCube);
    }
    removeStartEndPointCubes() {
        const scene = this.viewer.getScene();
        scene.remove(this.startPointCube);
        scene.remove(this.endPointCube);
    }
    handlePointSnap() {
        const closestVertex = this.getClosestVertex(this.closestIntersection, consts_1.consts.POINT_CUBE_VERTEX_SNAP_RADIUS);
        if (closestVertex) {
            this.cursorPointCube.position.copy(closestVertex);
            return;
        }
        const pointOnClosestEdge = this.getPointOnClosestEdge(this.closestIntersection);
        if (pointOnClosestEdge) {
            this.cursorPointCube.position.copy(pointOnClosestEdge);
        }
    }
    handleXDeltaLeader(xEndPoint) {
        if (!this.startPoint || !this.endPoint || !this.isValidDistance(this.startPoint, xEndPoint)) {
            this.xDeltaLeader.clear();
            return false;
        }
        const xDeltaLeaderDirReversed = xEndPoint.clone().sub(this.startPoint).negate().normalize();
        const intersection = this.getClosestLineObjectIntersection(this.startPointCube, xEndPoint, xDeltaLeaderDirReversed);
        const xLineStartPoint = intersection ? intersection.point : this.startPoint;
        this.xDeltaLeader.drawByLinePoints(this.startPoint, xEndPoint, xLineStartPoint, xEndPoint);
        return true;
    }
    handleYDeltaLeader(endPointCube, xEndPoint, yEndPoint) {
        if (!this.startPoint || !this.endPoint || !this.isValidDistance(xEndPoint, yEndPoint)) {
            this.yDeltaLeader.clear();
            return false;
        }
        const yDeltaLeaderDir = yEndPoint.clone().sub(xEndPoint).normalize();
        const yDeltaLeaderDirReversed = yDeltaLeaderDir.clone().negate();
        const outCubeIntersection = this.getClosestLineObjectIntersection(this.startPointCube, yEndPoint, yDeltaLeaderDirReversed);
        const yLineStartPoint = outCubeIntersection ? outCubeIntersection.point : xEndPoint;
        const inCubeIntersection = this.getClosestLineObjectIntersection(endPointCube, xEndPoint, yDeltaLeaderDir);
        const yLineEndPoint = inCubeIntersection ? inCubeIntersection.point : yEndPoint;
        this.yDeltaLeader.drawByLinePoints(xEndPoint, yEndPoint, yLineStartPoint, yLineEndPoint);
        return true;
    }
    handleZDeltaLeader(endPointCube, yEndPoint) {
        if (!this.startPoint || !this.endPoint || !this.isValidDistance(yEndPoint, this.endPoint)) {
            this.zDeltaLeader.clear();
            return false;
        }
        const zEndPoint = this.endPoint.clone();
        const zDeltaLeaderDir = zEndPoint.clone().sub(yEndPoint).normalize();
        const zDeltaLeaderDirReversed = zDeltaLeaderDir.clone().negate();
        const outCubeIntersection = this.getClosestLineObjectIntersection(this.startPointCube, zEndPoint, zDeltaLeaderDirReversed);
        const zLineStartPoint = outCubeIntersection ? outCubeIntersection.point : yEndPoint;
        const inCubeIntersection = this.getClosestLineObjectIntersection(endPointCube, yEndPoint, zDeltaLeaderDir);
        const zLineEndPoint = inCubeIntersection ? inCubeIntersection.point : zEndPoint;
        this.zDeltaLeader.drawByLinePoints(yEndPoint, zEndPoint, zLineStartPoint, zLineEndPoint);
        return true;
    }
    handleDistanceLeader(endPointCube) {
        if (!this.startPoint || !this.endPoint || !this.isValidDistance(this.startPoint, this.endPoint)) {
            this.distanceLeader.clear();
            return;
        }
        const distanceLeaderDir = this.endPoint.clone().sub(this.startPoint).normalize();
        const distanceLeaderDirReversed = distanceLeaderDir.clone().negate();
        const outCubeIntersection = this.getClosestLineObjectIntersection(this.startPointCube, this.endPoint, distanceLeaderDirReversed);
        const distanceLineStartPoint = outCubeIntersection ? outCubeIntersection.point : this.startPoint;
        const inCubeIntersection = this.getClosestLineObjectIntersection(endPointCube, this.startPoint, distanceLeaderDir);
        const distanceLineEndPoint = inCubeIntersection ? inCubeIntersection.point : this.endPoint;
        this.distanceLeader.drawByLinePoints(this.startPoint, this.endPoint, distanceLineStartPoint, distanceLineEndPoint);
    }
    handleLeaders() {
        if (!this.closestIntersection || !this.startPoint) {
            this.clearLeaders();
            this.endPoint = null;
            return;
        }
        this.endPoint = this.cursorPointCube.position.clone();
        const endPointCube = this.isMeasurementPlaced ? this.endPointCube : this.cursorPointCube;
        this.handleDistanceLeader(endPointCube);
        const xEndPoint = new three_1.Vector3(this.endPoint.x, this.startPoint.y, this.startPoint.z);
        let deltaLeadersDrawn = 0;
        if (this.handleXDeltaLeader(xEndPoint)) {
            deltaLeadersDrawn += 1;
        }
        const yEndPoint = new three_1.Vector3(this.endPoint.x, this.endPoint.y, this.startPoint.z);
        if (this.handleYDeltaLeader(endPointCube, xEndPoint, yEndPoint)) {
            deltaLeadersDrawn += 1;
        }
        if (this.handleZDeltaLeader(endPointCube, yEndPoint)) {
            deltaLeadersDrawn += 1;
        }
        if (deltaLeadersDrawn < 2) {
            this.clearDeltaLeaders();
        }
    }
    getClosestLineObjectIntersection(cube, rayOrigin, rayDir) {
        const raycaster = this.viewer.getRaycaster();
        raycaster.set(rayOrigin, rayDir);
        this.viewer.getScene().updateMatrixWorld();
        return raycaster.intersectObject(cube)[0];
    }
    isValidDistance(startPoint, endPoint) {
        return (0, utils_3d_1.areNotEqual)(startPoint.distanceTo(endPoint), 0.0);
    }
    clearDeltaLeaders() {
        this.xDeltaLeader.clear();
        this.yDeltaLeader.clear();
        this.zDeltaLeader.clear();
    }
    clearLeaders() {
        this.clearDeltaLeaders();
        this.distanceLeader.clear();
    }
    getClosestVertex(closestIntersection, maxRadius) {
        if (!closestIntersection) {
            return null;
        }
        const part = closestIntersection.object.parent;
        const intersectionPoint = closestIntersection.point;
        let closestVertex = null;
        let shortestDistance = null;
        part.selectionBox.vertices.forEach((vertex) => {
            const distance = intersectionPoint.distanceTo(vertex);
            const isShorterDistance = !shortestDistance || distance < shortestDistance;
            if (isShorterDistance) {
                shortestDistance = distance;
                closestVertex = vertex;
            }
        });
        if (!shortestDistance) {
            return null;
        }
        return shortestDistance < maxRadius ? closestVertex : null;
    }
    getPointOnClosestEdge(closestIntersection) {
        if (!closestIntersection) {
            return null;
        }
        const part = closestIntersection.object.parent;
        const boxEdges = EdgeUtils_3d_1.default.collectBBoxEdges(part);
        const intersectionPoint = closestIntersection.point;
        return EdgeUtils_3d_1.default.getPointOnClosestEdge(boxEdges, intersectionPoint);
    }
}
exports.default = PointToPointMeasureTool;
